module.exports = __webpack_public_path__ + "static/img/bc_qt_1.f94b641a.png";